import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import TaskModal from "./TaskModal";
import GeofenceController from "./GeofenceController";
import { Outlet, useLocation } from "react-router-dom";
import { workspaceFromPath } from "../lib/workspaces";

export default function AppLayout() {
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Determine default dashboard from current route for new-task quick add
  const dashboardForNew = workspaceFromPath(location.pathname) || "personal";

  return (
    <div className="flex h-[100dvh] bg-background text-foreground overflow-hidden">
      {/* Desktop sidebar */}
      <div className="hidden md:flex">
        <Sidebar />
      </div>

      {/* Mobile drawer */}
      {drawerOpen && (
        <div className="md:hidden fixed inset-0 z-40 flex">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setDrawerOpen(false)}
          />
          <div className="relative z-50">
            <Sidebar onClose={() => setDrawerOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <Header
          onNewTask={() => setTaskModalOpen(true)}
          search={search}
          setSearch={setSearch}
          onMenuClick={() => setDrawerOpen(true)}
        />
        <main
          className="flex-1 overflow-y-auto"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <Outlet context={{ search }} />
        </main>
      </div>

      <TaskModal
        open={taskModalOpen}
        onClose={() => setTaskModalOpen(false)}
        defaultDashboard={dashboardForNew}
      />
      <GeofenceController />
    </div>
  );
}
